// extracted by mini-css-extract-plugin
export default {"title":"title_title__6eVy1","title_h3":"title_title_h3__89OUu","title_h4":"title_title_h4__Dv57L","title_h5":"title_title_h5__FKm8g","title_h6":"title_title_h6__eA9-L"};